import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Users, Shield } from "lucide-react";
import { PlayerAvatar } from "./WeeklySpotlight";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const medal = (pos) => (pos === 1 ? "from-yellow-400 to-amber-500 text-black" : pos === 2 ? "from-gray-300 to-gray-400 text-black" : pos === 3 ? "from-amber-600 to-orange-700 text-white" : "from-purple-900 to-purple-800 text-gray-200");

export const TeamsRanking = ({ seasonId, searchQuery }) => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/ranking/teams${seasonId ? `?season_id=${seasonId}` : ""}`).then((r) => setTeams(r.data.teams || [])).catch(() => setTeams([])).finally(() => setLoading(false));
  }, [seasonId]);

  const list = teams.filter((t) => !searchQuery || t.nombre?.toLowerCase().includes(searchQuery.toLowerCase()));

  if (loading) return <div className="text-center py-16"><div className="w-12 h-12 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto" /></div>;
  if (!list.length) return <div className="text-center py-16 text-gray-400" data-testid="teams-empty"><Shield size={40} className="mx-auto mb-3 text-gray-600" /> No hay equipos para mostrar</div>;

  return (
    <div className="divide-y divide-purple-900/40" data-testid="teams-ranking">
      {list.map((t) => (
        <div key={t.id} className="hover:bg-purple-900/20 transition-colors">
          <button onClick={() => setOpen(open === t.id ? null : t.id)} className="w-full flex items-center gap-3 px-3 sm:px-4 py-3 text-left" data-testid={`team-row-${t.posicion}`}>
            <span className={`w-9 h-9 rounded-full bg-gradient-to-br ${medal(t.posicion)} font-black text-sm flex items-center justify-center flex-shrink-0`}>{t.posicion}</span>
            <div className="w-11 h-11 rounded-xl bg-purple-900/60 border border-purple-700/50 flex items-center justify-center text-yellow-400 overflow-hidden flex-shrink-0">
              {t.logo_url ? <img src={t.logo_url} alt="" className="w-full h-full object-cover" /> : <Shield size={20} />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-bold text-white truncate">{t.nombre}</p>
              <p className="text-[11px] text-gray-400 flex items-center gap-1"><Users size={11} /> {t.miembros} jugador{t.miembros !== 1 && "es"} · promedio {t.promedio} pts</p>
            </div>
            <div className="text-right">
              <p className="text-xl font-black bg-gradient-to-r from-yellow-400 to-amber-500 bg-clip-text text-transparent">{t.puntos}</p>
              <p className="text-[10px] text-gray-500 uppercase">puntos</p>
            </div>
          </button>
          {open === t.id && (
            <div className="px-4 pb-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-2" data-testid={`team-members-${t.posicion}`}>
              {t.jugadores.map((p, i) => (
                <div key={i} className="flex items-center gap-2 p-2 rounded-lg bg-black/30 border border-purple-900/40">
                  <PlayerAvatar player={p} size="w-8 h-8" text="text-xs" />
                  <Link to={`/jugador/${encodeURIComponent(p.Nombre || "")}`} className="text-sm text-gray-200 truncate flex-1 hover:text-yellow-300">{p.Nombre}</Link>
                  <span className="text-xs font-bold text-yellow-300">{p.Total}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
